/**
 * FilterPopover — popover chuẩn để chứa nội dung filter (Search input,
 * Select dropdown, Date range...). Pair với useFilterPopover.
 *
 * SearchFilterContent — nội dung sẵn sàng cho filter "Search":
 *   - TextField full-width, autoFocus
 *   - "Clear Search" text button
 *
 * Filter Area "Search" contract: search toàn bộ cột của bảng dữ liệu
 * (thực thi qua useTableSearch). Component này CHỈ là UI cho input,
 * không tự filter — caller wire state qua useTableSearch.
 */
import { type ReactNode } from 'react'
import { Button, Popover, Stack, TextField } from '@mui/material'

export interface FilterPopoverProps {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
  children: ReactNode
  /** Override min/max width (default 240–360). */
  minWidth?: number
  maxWidth?: number
}

export function FilterPopover({
  open,
  anchorEl,
  onClose,
  children,
  minWidth = 240,
  maxWidth = 360,
}: FilterPopoverProps) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{ sx: { p: 1.5, minWidth, maxWidth } }}
    >
      {children}
    </Popover>
  )
}

export interface SearchFilterContentProps {
  value: string
  onChange: (next: string) => void
  /** Helper text dưới label — gợi ý field hay search (Contract No, vendor...). */
  placeholder?: string
  /** Gọi khi user bấm Clear Search — thường: reset value + close popover + reset page. */
  onClear?: () => void
  label?: string
}

export function SearchFilterContent({
  value,
  onChange,
  placeholder,
  onClear,
  label = 'Search',
}: SearchFilterContentProps) {
  return (
    <Stack spacing={1}>
      <TextField
        size="small"
        fullWidth
        autoFocus
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button
        size="small"
        variant="text"
        onClick={() => {
          onChange('')
          onClear?.()
        }}
      >
        Clear Search
      </Button>
    </Stack>
  )
}
